import { FC, JSX } from 'react';
import { Grid } from '@mui/material';
// components
import BaseCoatingForm from './Form';
// interfaces
import { BaseCoatingFormProps } from 'interfaces';

const AddBaseCoatingForm: FC<BaseCoatingFormProps> = ({ loading, isEdit = false }): JSX.Element => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={6} md={12}>
        <BaseCoatingForm loading={loading} isEdit={isEdit} />
      </Grid>
    </Grid>
  );
};

export default AddBaseCoatingForm;
